export const UserValidation = (values) => {
    let errors = {};

    if (!values?.firstName?.trim()) {
        errors.firstName = "Enter firstname";
    }
    if (values?.firstName === "") {
        errors.firstName = "Enter firstname";
    }
    if (!values?.lastName?.trim()) {
        errors.lastName = "Enter lastname";
    }
    if (!values?.address?.trim()) {
        errors.address = "Enter location";
    }
    return errors;
};
